import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN || "https://88922bab738ba0021392a98b2ff961e8@o4511204021960704.ingest.us.sentry.io/4511204025171968";
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "ResizeObserver loop",
      "ResizeObserver loop completed with undelivered notifications",
      "Loading chunk",
      "ChunkLoadError",
      "NetworkError",
      "AbortError",
      "Failed to fetch",
      "Load failed",
      "Network request failed",
      "SecurityError: Failed to register a ServiceWorker",
      "ServiceWorker",
      "Should have a queue",
      "observer.getOptimisticResult is not a function",
    ],
    beforeSend(event) {
      // Filter out errors from browser extensions
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
        (frame) => frame.filename?.includes("extension://")
      )) {
        return null;
      }
      // Filter HMR-only noise outside production
      if (environment !== "production") {
        const msg = event.exception?.values?.[0]?.value || "";
        if (/Should have a queue|getOptimisticResult/.test(msg)) {
          return null;
        }
      }
      return event;
    },
  });
}

export function setSentryUser(id: string, email?: string | null) {
  Sentry.setUser({ id, ...(email ? { email } : {}) });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
